// import { useParams, useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { AnimatePresence } from "framer-motion";
// import MainLayout from "../sidebar/Sidebar";
// import ReceiptEditInterface from "../components/ReceiptEditInterface";
// import api from "../api/api.js";

// export default function ReceiptDetail() {
//   const { id: receiptId } = useParams();
//   const navigate = useNavigate();
//   const [receipt, setReceipt] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [location, setLocation] = useState("Receipt Details");

//   useEffect(() => {
//     async function fetchReceipt() {
//       setLoading(true);
//       setError("");
//       try {
//         const response = await api.get(`/receipts/${receiptId}`);
//         setReceipt(response.data);
//       } catch (err) {
//         setError("Failed to load receipt details.");
//       }
//       setLoading(false);
//     }
//     fetchReceipt();
//   }, [receiptId]);

//   const openEditMode = () => {
//     setIsEditMode(true);
//   };

//   const closeEditMode = () => {
//     setIsEditMode(false);
//   };

//   const handleSave = async () => {
//     // Refresh receipt data after save
//     try {
//       const response = await api.get(`/receipts/${receiptId}`);
//       setReceipt(response.data);
//       setIsEditMode(false);
//     } catch (err) {
//       console.error("Failed to refresh receipt data:", err);
//     }
//   };

//   // Format date string without timezone conversion
//   const formatDate = (dateString) => {
//     // For date-only strings (YYYY-MM-DD), parse as local date to avoid timezone issues
//     const [year, month, day] = dateString.split("-");
//     const date = new Date(year, month - 1, day); // month is 0-indexed
//     return date.toLocaleDateString();
//   };

//   return (
//     <MainLayout location={location} setLocation={setLocation}>
//       <div className="h-screen overflow-y-auto bg-gray-50 px-6 py-10">
//         <div className="max-w-5xl mx-auto">
//           {/* Back Button */}
//           <button
//             className="text-blue-600 hover:underline mb-6"
//             onClick={() => navigate("/receipts")}
//           >
//             &larr; Back to Receipts
//           </button>

//           {/* Title */}
//           <div className="mb-8">
//             <span className="text-lg font-semibold uppercase text-green-600 bg-green-100 px-3 py-1 rounded-full">
//               Receipt Details
//             </span>
//           </div>

//           {/* Loading / Error / Empty */}
//           {loading && (
//             <div className="text-gray-600">Loading receipt details...</div>
//           )}
//           {error && <div className="text-red-600">{error}</div>}
//           {!loading && !error && !receipt && (
//             <div className="text-gray-500">No receipt details found.</div>
//           )}

//           {receipt && (
//             <div className="space-y-6">
//               {/* Receipt Information */}
//               <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200">
//                 <h2 className="text-lg font-semibold text-gray-900 mb-2">
//                   {receipt.original_name}
//                 </h2>
//                 <div className="text-gray-700 text-sm mb-1">
//                   Status: {receipt.processing_status}
//                 </div>
//                 <div className="text-gray-500 text-sm italic mb-1">
//                   Uploaded: {new Date(receipt.created_at).toLocaleDateString()}
//                 </div>
//                 <div className="text-gray-600 text-sm">
//                   File Size: {(receipt.file_size / 1024).toFixed(2)} KB
//                 </div>
//                 <div className="text-gray-600 text-sm">
//                   Content Type: {receipt.content_type}
//                 </div>
//                 {receipt.s3_url && (
//                   <div className="mt-4">
//                     <button
//                       onClick={openEditMode}
//                       className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//                     >
//                       View/Edit Receipt
//                     </button>
//                   </div>
//                 )}
//               </div>

//               {/* Receipt Summary */}
//               {receipt.receipt_data && (
//                 <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200">
//                   <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                     Receipt Details
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     {receipt.receipt_data.merchant_name && (
//                       <div>
//                         <span className="text-gray-600 text-sm">Merchant:</span>
//                         <div className="font-medium">
//                           {receipt.receipt_data.merchant_name}
//                         </div>
//                       </div>
//                     )}
//                     {receipt.receipt_data.date && (
//                       <div>
//                         <span className="text-gray-600 text-sm">Date:</span>
//                         <div className="font-medium">
//                           {formatDate(receipt.receipt_data.date)}
//                         </div>
//                       </div>
//                     )}
//                     {receipt.receipt_data.subtotal_amount && (
//                       <div>
//                         <span className="text-gray-600 text-sm">Subtotal:</span>
//                         <div className="font-medium">
//                           ${receipt.receipt_data.subtotal_amount.toFixed(2)}
//                         </div>
//                       </div>
//                     )}
//                     {receipt.receipt_data.tax_amount && (
//                       <div>
//                         <span className="text-gray-600 text-sm">Tax:</span>
//                         <div className="font-medium">
//                           ${receipt.receipt_data.tax_amount.toFixed(2)}
//                         </div>
//                       </div>
//                     )}
//                     {receipt.receipt_data.total_amount && (
//                       <div>
//                         <span className="text-gray-600 text-sm">Total:</span>
//                         <div className="font-bold text-lg text-green-600">
//                           ${receipt.receipt_data.total_amount.toFixed(2)}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}

//               {/* Line Items */}
//               {receipt.receipt_data &&
//                 receipt.receipt_data.line_items &&
//                 receipt.receipt_data.line_items.length > 0 && (
//                   <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200">
//                     <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                       Line Items
//                     </h3>
//                     <div className="overflow-x-auto">
//                       <table className="w-full table-auto">
//                         <thead>
//                           <tr className="border-b border-gray-200">
//                             <th className="text-left py-2 px-3 text-sm font-medium text-gray-700">
//                               Item
//                             </th>
//                             <th className="text-center py-2 px-3 text-sm font-medium text-gray-700">
//                               Qty
//                             </th>
//                             <th className="text-right py-2 px-3 text-sm font-medium text-gray-700">
//                               Unit Price
//                             </th>
//                             <th className="text-right py-2 px-3 text-sm font-medium text-gray-700">
//                               Total
//                             </th>
//                             <th className="text-center py-2 px-3 text-sm font-medium text-gray-700">
//                               Category
//                             </th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {receipt.receipt_data.line_items.map(
//                             (item, index) => (
//                               <tr
//                                 key={index}
//                                 className="border-b border-gray-100 hover:bg-gray-50"
//                               >
//                                 <td className="py-3 px-3 text-sm text-gray-900">
//                                   {item.name || "Unknown Item"}
//                                 </td>
//                                 <td className="py-3 px-3 text-sm text-gray-600 text-center">
//                                   {item.quantity || 1}
//                                 </td>
//                                 <td className="py-3 px-3 text-sm text-gray-600 text-right">
//                                   {item.unit_price
//                                     ? `$${item.unit_price.toFixed(2)}`
//                                     : "-"}
//                                 </td>
//                                 <td className="py-3 px-3 text-sm font-medium text-gray-900 text-right">
//                                   {item.total_price
//                                     ? `$${item.total_price.toFixed(2)}`
//                                     : "-"}
//                                 </td>
//                                 <td className="py-3 px-3 text-center">
//                                   {item.category && (
//                                     <span className="inline-block px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
//                                       {item.category}
//                                     </span>
//                                   )}
//                                 </td>
//                               </tr>
//                             )
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 )}

//               {/* Show processing status for pending receipts */}
//               {receipt.processing_status === "pending" && (
//                 <div className="bg-yellow-50 rounded-2xl p-6 border border-yellow-200">
//                   <div className="flex items-center">
//                     <div className="w-4 h-4 border-2 border-yellow-600 border-t-transparent rounded-full animate-spin mr-3"></div>
//                     <div>
//                       <h3 className="text-lg font-semibold text-yellow-800">
//                         Processing Receipt
//                       </h3>
//                       <p className="text-yellow-700 text-sm">
//                         Line items will appear here once processing is complete.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Show error for failed processing */}
//               {receipt.processing_status === "failed" && (
//                 <div className="bg-red-50 rounded-2xl p-6 border border-red-200">
//                   <h3 className="text-lg font-semibold text-red-800">
//                     Processing Failed
//                   </h3>
//                   <p className="text-red-700 text-sm">
//                     Unable to extract line items from this receipt.
//                   </p>
//                 </div>
//               )}

//               {/* Show when no line items found but processing completed */}
//               {receipt.processing_status === "completed" &&
//                 (!receipt.receipt_data ||
//                   !receipt.receipt_data.line_items ||
//                   receipt.receipt_data.line_items.length === 0) && (
//                   <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200">
//                     <h3 className="text-lg font-semibold text-gray-800">
//                       No Line Items Found
//                     </h3>
//                     <p className="text-gray-600 text-sm">
//                       No individual items could be extracted from this receipt.
//                     </p>
//                   </div>
//                 )}
//             </div>
//           )}

//           {isEditMode && receipt && (
//             <AnimatePresence>
//               <ReceiptEditInterface
//                 receipt={receipt}
//                 onClose={closeEditMode}
//                 onSave={handleSave}
//               />
//             </AnimatePresence>
//           )}
//         </div>
//       </div>
//     </MainLayout>
//   );
// }
import { useState, useEffect } from "react";
import ReceiptListDesktop from "../ReceiptDetail/ReceiptListDesktop.js";
import ReceiptListMobile from "../ReceiptDetail/ReceiptListMobile.js";

const ReceiptList = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      const width = window.innerWidth;
      const userAgent = navigator.userAgent;

      const isMobileWidth = width < 768;

      const isMobileUserAgent =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );

      return isMobileWidth || isMobileUserAgent;
    };

    setIsMobile(checkIsMobile());

    const handleResize = () => {
      setIsMobile(checkIsMobile());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile ? <ReceiptListMobile /> : <ReceiptListDesktop />;
};

export default ReceiptList;
